import _toConsumableArray from "E:/smartlink/front/lianhe/ctruck-lock-front/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.string.sub";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ContantSearch',
  props: {
    lastFew: {
      type: Number,
      default: 1
    },
    ykRow: {
      type: Boolean,
      default: false
    },
    initOnChangeTab: {
      type: String,
      default: null
    },
    defaultTab: {
      type: String,
      default: null
    }
  },
  data: function data() {
    return {
      actionSub: {
        sub: -1,
        width: 0
      },
      parentWidth: 0,
      childrenDom: [],
      laseFewWidth: 0,
      show: true,
      showMore: false,
      iconClass: 'chevron-down-outline',
      btnTop: -1000,
      timeOutObj: null
    };
  },
  watch: {
    initOnChangeTab: function initOnChangeTab(newValue, oldValue) {
      console.log('initChangeTab变化了', newValue, this.defaultTab);
      if (newValue === this.defaultTab) {
        this.init();
      }
    }
  },
  deactivated: function deactivated() {
    this.remvoerResize();
  },
  activated: function activated() {
    this.init();
  },
  mounted: function mounted() {
    this.init();
  },
  beforeDestroy: function beforeDestroy() {
    this.remvoerResize();
  },
  methods: {
    remvoerResize: function remvoerResize() {
      window.removeEventListener('resize', this.resizeFun);
    },
    liseterResize: function liseterResize() {
      window.addEventListener('resize', this.resizeFun);
    },
    resizeFun: function resizeFun() {
      var _this = this;
      if (this.ykRow) return;
      if (this.showMore) {
        clearTimeout(this.timeOutObj);
        this.timeOutObj = setTimeout(function () {
          _this.computedFun();
          _this.timeOutObj = null;
        }, 500);
      } else {
        var childWidth = 0;
        var parentDom = this.$slots.default;
        var newParentWidth = parentDom[0].elm.offsetWidth - this.attributeWidthNum(parentDom[0].elm, 'padding');
        var lastWidth = this.laseFewWidth + this.$refs.btn.$el.offsetWidth + 16;
        for (var i = 0; i < this.childrenDom.length; i++) {
          childWidth += this.childrenDom[i].offsetWidth + this.attributeWidthNum(this.childrenDom[i]);
        }
        if (newParentWidth > lastWidth + childWidth) {
          this.show = false;
          this.actionSub = {
            sub: -1,
            width: 0
          };
          this.parentWidth = 0;
        } else {
          this.show = true;
          var _parentDom = this.$slots.default;
          var parentHeight = _parentDom[0].elm.offsetHeight - 20;
          this.btnTop = parentHeight - 36;
        }
      }
    },
    changeStauts: function changeStauts() {
      this.showMore = !this.showMore;
      this.iconClass = this.showMore ? 'chevron-down-outline' : 'chevron-up-outline';
      if (!this.showMore) {
        for (var i = 0; i < this.childrenDom.length; i++) {
          if (this.ykRow) {
            this.childrenDom[i].parentElement.classList.remove('hidden');
          } else {
            this.childrenDom[i].style.display = '';
          }
        }
        var parentDom = this.$slots.default;
        var parentHeight = parentDom[0].elm.offsetHeight - 20;
        this.btnTop = parentHeight - 36;
      } else {
        this.actionSub = {
          sub: -1,
          width: 0
        };
        this.parentWidth = 0;
        this.computedFun();
      }
    },
    init: function init() {
      var _this2 = this;
      this.remvoerResize();
      this.liseterResize();
      var parentDom = this.$slots.default;
      this.$nextTick(function () {
        // console.log('parentDom', parentDom, parentDom[0], parentDom[0].elm);
        _this2.actionSub = {
          sub: -1,
          width: 0
        };
        _this2.parentWidth = 0;
        _this2.childrenDom = [];
        _this2.laseFewWidth = 0;
        _this2.show = true;
        _this2.showMore = false;
        _this2.iconClass = 'chevron-down-outline';
        _this2.btnTop = -1000;
        _this2.timeOutObj = null;
        if (parentDom.length && parentDom[0].elm.children.length) {
          _this2.initChildAry();
          _this2.computedFun();
        }
      });
    },
    computedFun: function computedFun() {
      var childWidth = this.actionSub.width;
      this.laseFewWidth = 0;
      for (var j = 0; j < this.lastFew; j++) {
        // console.log(j+'----.offsetWidth', this.childrenDom[ this.childrenDom.length - 1 - j].offsetWidth);
        this.laseFewWidth += this.childrenDom[this.childrenDom.length - 1 - j].offsetWidth + this.attributeWidthNum(this.childrenDom[this.childrenDom.length - 1 - j]);
      }
      var lastWidth = this.laseFewWidth + this.$refs.btn.$el.offsetWidth + 16;
      var parentDom = this.$slots.default;
      // console.log('parentDom[0].elm.offsetWidth', parentDom[0].elm.offsetWidth, this.$refs.btn.$el.offsetWidth);
      var newParentWidth = parentDom[0].elm.offsetWidth - this.attributeWidthNum(parentDom[0].elm, 'padding');
      // 根据总宽度，指针前移后移 == 初始化时使用
      if (newParentWidth >= this.parentWidth) {
        // console.log('后移')
        for (var i = this.actionSub.sub + 1; i < this.childrenDom.length - this.lastFew; i++) {
          if (this.ykRow) {
            this.childrenDom[i].parentElement.classList.remove('hidden');
          } else {
            this.childrenDom[i].style.display = '';
          }
          if (this.childrenDom[i].className === 'teamtree-car') {
            var arr = this.childrenDom[i].children[0].children;
            // console.log('arr', arr);
            var treeWidth = 0;
            // debugger
            for (var y = 0; y < arr.length; y++) {
              if (arr[y].clientHeight) {
                treeWidth += arr[y].children[0].offsetWidth + this.attributeWidthNum(arr[y].children[0]);
              }
            }
            childWidth += treeWidth;
          } else {
            childWidth += this.childrenDom[i].offsetWidth + this.attributeWidthNum(this.childrenDom[i]);
          }
          // console.log({
          //   [i]:childWidth,
          //   test:this.childrenDom[i]
          // });
          if (childWidth + lastWidth < newParentWidth) {
            this.actionSub = {
              sub: i,
              width: childWidth
            };
            this.btnTop = 16;
            this.show = true;
            this.showMore = true;
          } else {
            if (this.ykRow) {
              this.childrenDom[i].parentElement.classList.add('hidden');
            } else {
              this.childrenDom[i].style.display = 'none';
            }
          }
          if (i === this.childrenDom.length - 1 - this.lastFew && newParentWidth > childWidth + lastWidth) {
            this.show = false;
          }
        }
      } else {
        // console.log('前移')
        for (var _i = this.actionSub.sub; _i >= 0; _i--) {
          if (newParentWidth < childWidth + lastWidth) {
            childWidth -= this.childrenDom[_i].offsetWidth + this.attributeWidthNum(this.childrenDom[_i]);
            this.actionSub = {
              sub: _i,
              width: childWidth
            };
            this.btnTop = 16;
            this.show = true;
            this.showMore = true;
            if (this.ykRow) {
              this.childrenDom[_i].parentElement.classList.add('hidden');
            } else {
              this.childrenDom[_i].style.display = 'none';
            }
            // console.log({ 111:this.childrenDom[i] });
          } else {
            childWidth -= this.childrenDom[_i].offsetWidth + this.attributeWidthNum(this.childrenDom[_i]);
          }
        }
      }
      this.parentWidth = newParentWidth;
    },
    initChildAry: function initChildAry() {
      var parentDom = this.$slots.default;
      if (parentDom.length && parentDom[0].elm.children.length) {
        var childDomAry = parentDom[0].elm.children;
        // console.log('childDomAry', childDomAry);
        for (var i = 0; i < childDomAry.length; i++) {
          if (childDomAry[i].className.includes('teamtree-car')) {
            // 处理嵌套组件层级不同
            var _c = this.teamtreeCarDom(childDomAry[i]);
            for (var s = 0; s < _c.length; s++) {
              this.childrenDom.push(_c[s]);
            }
          } else if (childDomAry[i].className.includes('el-row') || childDomAry[i].className.includes('el-row')) {
            var _d = this.ykRowDom(childDomAry[i]);
            for (var _s = 0; _s < _d.length; _s++) {
              this.childrenDom.push(_d[_s]);
            }
          } else {
            this.childrenDom.push(childDomAry[i]);
          }
        }
      }
    },
    attributeWidthNum: function attributeWidthNum(dom) {
      var attributeName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'margin';
      var width = 0;
      if (dom) {
        var attributeStr = document.defaultView.getComputedStyle(dom)[attributeName];
        var reg = new RegExp('px', 'g');
        var Ary = attributeStr.replace(reg, '').split(' ');
        if (Ary.length === 2 || Ary.length === 3) {
          width = Number(Ary[1]) * 2;
        }
        if (Ary.length === 4) {
          width = Number(Ary[1]) + Number(Ary[3]);
        }
        if (Ary.length === 1) {
          width = attributeName === 'margin' || this.attributeWidthNum === 'padding' ? Number(Ary[0]) * 2 : Number(Ary[0]);
        }
      }
      return width;
    },
    teamtreeCarDom: function teamtreeCarDom(dom) {
      var childDom = dom.children[0].children;
      return childDom;
    },
    ykRowDom: function ykRowDom(dom) {
      var childDom = dom.children;
      var temp = [];
      // console.log('childDom', childDom);
      for (var i = 0; i < childDom.length; i++) {
        if ((childDom[i].className.includes('el-col-8') || childDom[i].className.includes('el-col-8')) && childDom[i].children[0].className.includes('teamtree-car')) {
          var _e = childDom[i].children[0].children[0].children;
          for (var j = 0; j < _e.length; j++) {
            temp.push.apply(temp, _toConsumableArray(_e[j].children));
          }
        } else if (childDom[i].className.includes('el-col') || childDom[i].className.includes('el-col')) {
          temp.push.apply(temp, _toConsumableArray(childDom[i].children));
        }
      }
      // console.log({ temp:temp });
      return temp;
    }
  }
};